define('view/controller/booking/result/BookingResultItemView',['require','lib/view/LayoutView','lib/view/ModalRegion','view/controller/booking/result/BookingCancellationDialogView','view/controller/booking/result/BookingCancellationErrorView','model/CancelBookingReasonModel','Config'],function (require) {

    var LayoutView = require('lib/view/LayoutView');
    var ModalRegion = require('lib/view/ModalRegion');
    var BookingCancellationDialogView = require('view/controller/booking/result/BookingCancellationDialogView');
    var BookingCancellationErrorView = require('view/controller/booking/result/BookingCancellationErrorView');
    var CancelBookingReasonModel = require('model/CancelBookingReasonModel');
    var Config = require('Config');
	
	/**
	 * Booking information item in result view
	 * 
	 * @class BookingResultItemView
	 */
	return LayoutView.extend({

        template: '#booking_result_item',
        ui: {
            cancelBtn: '.sb_cancel_btn'
        },
        events: {
            'click @ui.cancelBtn': 'cancelBookingDialog'
        },
        dialogRegionEl: '#sb_dialog',

        initialize: function () {
            if (this.getOption('clientTimeZone')) {
                this.listenTo(this.getOption('clientTimeZone'), 'sync', this.render);
            }
        },

        cancelBookingDialog: function () {
            var region = new ModalRegion({
                closeOnBackdropClick: true
            });
            var view = new BookingCancellationDialogView({
                model : new CancelBookingReasonModel(),
                bookingModel: this.model
            });
            region.show(view);

            this.listenTo(view, 'confirm', this.cancelBooking);
        },

        cancelBooking: function (data) {
            this.model.set({'_cancel_batch': data.batch}, {silent: true}); // for success notification to know, whether there was a batch
            
            this.model.destroy({
                wait: true,
                url: _.result(this.model, this.model.get('wl')?'url_waiting_list':'url'),
                data: {
                    id : this.model.get('id'),
                    hash : this.model.get('hash'),
                    wl: this.model.get('wl'),
                    reason : data.reason,
                    batch: data.batch
                },
                processData: true,
                error: _.bind(this.cancelBookingError, this),
                success: function () {
                    data.region.hide();
                }
            });
        },

        cancelBookingError: function (model, xhr, options) {
            var result = xhr.responseJSON;
            if (result && result.error) {
                var region = new ModalRegion();
                var view = new BookingCancellationErrorView({
                    model: this.model,
                    error: result.error
                });
                region.show(view);
            }
        },

        serializeData: function () {
            var data = LayoutView.prototype.serializeData.apply(this);
            if (parseInt(Config.getInstance().getOption('show_booking_page_in_client_timezone'))) {
                if (data.time_offset) {
                    data.time_diff = data.time_offset;
                } else if (this.getOption('clientTimeZone')) {
                    data.time_diff = this.getOption('clientTimeZone').get('time_diff');
                }
            }
            if (data.status) {
                data.status_text = 'status_' + data.status;
            }
            data.highlighted = this.getOption('highlighted');
            data.wl = this.getOption('wl');

            // console.log('Booking data', data);
            
            return data;
        }

    });
	
});
